import { computed, ref, type ModelRef } from 'vue'

export const useCommonDialog = (
  isOpenModel: ModelRef<boolean | undefined, string, boolean | undefined, boolean | undefined>
) => {
  const isOpen = ref(false)
  const refResolve = ref<((value: string | PromiseLike<string>) => void) | null>(null)
  const refReject = ref<((value: string | PromiseLike<string>) => void) | null>(null)

  const openDialog = () => {
    isOpenComputed.value = true
    return new Promise<string>((resolve, reject) => {
      refResolve.value = resolve
      refReject.value = reject
    })
  }

  const isOpenComputed = computed({
    get: () => (isOpenModel.value !== undefined ? isOpenModel.value : isOpen.value),
    set: (value: boolean) =>
      isOpenModel.value !== undefined ? (isOpenModel.value = value) : (isOpen.value = value)
  })

  const ok = () => {
    isOpenComputed.value = false
    refResolve.value?.('ok')
  }
  const cancel = () => {
    isOpenComputed.value = false
    if (!isOpenModel.value) {
      refReject.value?.('cancel')
    }
  }

  return {
    isOpen,
    openDialog,
    ok,
    cancel,
    isOpenModel,
    isOpenComputed
  }
}
